export default "__VITE_ASSET__CnR9ldCB__"